import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-btn-edit',
	templateUrl: './btn-edit-pencil.component.html',
	styleUrls: ['./btn-edit-pencil.component.scss'],
})
export class BtnEditPencilComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
